export const UNDEFINED_RECORD_CODE = 'DEFAULT';
export const DSM_MAX_FILE_ROWS = 5000;
export const PROGRAMMATIC_MAX_FILE_ROWS = 5000;
